import { Container, PlaybackTimeLabel, PlaybackTimeLabelMode, SeekBar, SeekBarLabel } from 'bitmovin-player-ui';
export function createSeekBar(npoplayer) {
    const seekBar = new SeekBar({ label: new SeekBarLabel() });
    npoplayer.uiComponents.seekBar = seekBar;
    return new Container({
        components: [
            new PlaybackTimeLabel({
                timeLabelMode: PlaybackTimeLabelMode.CurrentTime,
                hideInLivePlayback: true,
                cssClasses: ['current-time']
            }),
            seekBar,
            new PlaybackTimeLabel({
                timeLabelMode: PlaybackTimeLabelMode.TotalTime,
                cssClasses: ['total-time']
            })
        ],
        cssClasses: ['controlbar-top', 'controlbar-seekbar']
    });
}
